/* eslint-disable camelcase */
import React from 'react'
import QuestionAnswer from './QuestionAnswer'
import fineprintStyles from './fineprint.module.sass'
import ButtonLink from './ButtonLink'

const buttonProps = {
  url: 'mailto:oink@trufflepigs.com',
  text: 'Have a question? Ask us!',
  variant: '',
  addClass: fineprintStyles.button,
}
export default props => {
  const { addClasses, faq, section, show_button } = props

  // console.log(faq)

  const addHeadingClasses = fineprintStyles.faqheading
  const addListClasses = fineprintStyles.faqlist

  return (
    <div className={[fineprintStyles.fineprint, addClasses].join(' ')}>
      <div className={fineprintStyles.content}>
        <h3 className={[fineprintStyles.heading, addHeadingClasses].join(' ')}>
          {section}
        </h3>
        <ul className={[fineprintStyles.list, addListClasses].join(' ')}>
          {faq.map((qa, index) => (
            <QuestionAnswer
              qa={qa}
              addClasses={fineprintStyles.qa}
              key={index}
            />
          ))}
        </ul>
        {show_button && <ButtonLink {...buttonProps} />}
      </div>
    </div>
  )
}
